// extracted by mini-css-extract-plugin
export var bodyFont = "styels-module--body-font--bbbfd";
export var date_time_picker = "styels-module--date_time_picker--113be";
export var titleFont = "styels-module--title-font--5cb9e";